var render = function () {
  var _vm$eventFlowItem$res;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.rowStart < _vm.lastPos && _vm.rowEnd > 1 ? _c('div', {
    staticClass: "event-flow-item",
    class: {
      extended: _vm.extraFunctionFormData.showTime || _vm.extraFunctionFormData.showBrief
    },
    style: {
      'grid-column': _vm.index + 1,
      'grid-row-start': _vm.rowStart,
      'grid-row-end': _vm.rowEnd,
      'background-color': (_vm$eventFlowItem$res = _vm.eventFlowItem.responsible) === null || _vm$eventFlowItem$res === void 0 ? void 0 : _vm$eventFlowItem$res.color
    },
    on: {
      "click": function click($event) {
        return _vm.click(_vm.eventFlowItem);
      }
    }
  }, [_c('div', {
    staticClass: "brief-top",
    class: {
      'brief-bottom': _vm.rowStart < 3,
      'brief-top-inside': _vm.rowStart < 3 && _vm.rowEnd > _vm.lastPos - 2,
      'extended': _vm.extraFunctionFormData.showTime || _vm.extraFunctionFormData.showBrief
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.extraFunctionFormData.showTime,
      expression: "extraFunctionFormData.showTime"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.eventFlowItem.startedAt.toLocaleTimeString(this.$i18n.locale, _vm.timeFormatOptions)) + " "), _c('div', {
    staticClass: "divider"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.eventFlowItem.endedAt.toLocaleTimeString(this.$i18n.locale, _vm.timeFormatOptions)) + " ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.extraFunctionFormData.showBrief,
      expression: "extraFunctionFormData.showBrief"
    }]
  }, [_vm._v(" " + _vm._s(_vm.eventFlowItem.brief) + " ")])]), !_vm.isSheet && _vm.canMoveTop(_vm.eventFlowItem) ? _c('div', {
    staticClass: "resize resize-top",
    attrs: {
      "draggable": ""
    },
    on: {
      "drag": function drag($event) {
        return _vm.throttleModifyStart($event, _vm.eventFlowItem);
      },
      "dragstart": function dragstart($event) {
        return _vm.onDragStart($event);
      },
      "dragend": function dragend($event) {
        return _vm.updateItem(_vm.eventFlowItem);
      }
    }
  }) : _vm._e(), !_vm.isSheet ? _c('div', {
    staticClass: "drag",
    attrs: {
      "draggable": ""
    },
    on: {
      "drag": function drag($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.throttleMoveItem($event, _vm.eventFlowItem);
      },
      "dragstart": function dragstart($event) {
        return _vm.onDragStartMovement($event, _vm.eventFlowItem);
      },
      "dragend": function dragend($event) {
        return _vm.onDragEndMovement(_vm.eventFlowItem);
      }
    }
  }) : _vm._e(), !_vm.isSheet && _vm.canMoveBottom(_vm.eventFlowItem) ? _c('div', {
    staticClass: "resize resize-bottom",
    attrs: {
      "draggable": ""
    },
    on: {
      "drag": function drag($event) {
        return _vm.throttleModifyEnd($event, _vm.eventFlowItem);
      },
      "dragstart": function dragstart($event) {
        return _vm.onDragStart($event);
      },
      "dragend": function dragend($event) {
        return _vm.updateItem(_vm.eventFlowItem);
      }
    }
  }) : _vm._e()]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }